import { render, staticRenderFns } from "./RefereeList.vue?vue&type=template&id=5c815a9c&scoped=true&"
import script from "./RefereeList.vue?vue&type=script&lang=js&"
export * from "./RefereeList.vue?vue&type=script&lang=js&"
import style0 from "./RefereeList.vue?vue&type=style&index=0&id=5c815a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c815a9c",
  null
  
)

export default component.exports